<template>
  <div>
    <top></top>
    <el-carousel style="width: 100%;height: 320px;" indicator-position="none">
      <el-carousel-item style="width: 100%;height: 320px;">
        <img class="swiper-img" src="../../../static/images/swiper4.jpg"/>
      </el-carousel-item>
    </el-carousel>
    <menutree :menuchild="menuchild" checkMenu="2" :rightBars="rightBars"></menutree>
    <div class="aboutus_content_box">
      <div class="aboutus_content">
        <div class="newsList">
          <div class="news_box pointer" v-for="(item,index) in dataList" :key="index" @click="goReportInfo(item)">
           <el-card shadow="hover">
             <div>
                <el-image style="width: 240px;height: 240px;" class="news_img" fit='cover' :src="'https://www.hzshjc.com/' + item.picture"></el-image>
             </div>
             <div class="news_title">
               {{item.title}}
             </div>
           </el-card>
          </div>
        </div>
        <div class="pagination_box" v-if="dataList.length > 0">
          <el-pagination
            background
            layout="prev, pager, next"
            :total="total">
          </el-pagination>
        </div>
      </div>
    </div>
    <bottom></bottom>
  </div>
</template>

<script>
import top from '@/components/top.vue';
import menutree from '@/components/menutree.vue';
import bottom from '@/components/bottom.vue';
export default {
  components:{top,menutree,bottom},
  data () {
    return {
      dataList:[],
      total:1,
      page:1,
      searchValue:'',
      menuchild:[{
        lable:'职业卫生报告',
        value:'1',
        path:'/reports'
      },{
        lable:'信息公示',
        value:'3',
        path:'/publicNotice'
      },{
        lable:'新闻资讯',
        value:'2',
        path:'/newsList'
      }],
      rightBars:[{
        lable:'首页',
        path:'/',
      },{
        lable:'信息公开',
        path:'',
      },{
        lable:'新闻资讯',
        path:'',
      }]
    }
  },
  mounted() {
    this.getData()
  },
  methods:{
    goReportInfo(item){
      const{ href } = this.$router.resolve({name:'newsInfo',query:{id:item.id}})
      // console.log(newPage)
      window.open(href,'_blank')
    },
    getData(){
      const loading = this.$loading({
        lock: true,
        text: '加载中...',
        spinner: 'el-icon-loading',
        background:'rgba(0, 0, 0, 0)'
      });
      const url='https://api.hzshjc.com/index/newsList';
      let data = {
        pageSize:10,
        pageNo:this.page,
        searchValue:this.searchValue
      }
      this.$axios({
        method:'get',
        url:url,
        params:data
      }).then(res=>{
        if(res.data.code=='200'){
          this.dataList = res.data.rows;
          this.total = res.data.total;
        }
        loading.close()
      })
    }
  }
}
</script>

<style scope lang="less">
  .swiper-img{
    width: 100%;
    height: 320px;
  }
  .aboutus_content_box{
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: calc(50vh);
    .aboutus_content{
      width: 1200px;
      font-size: 14px;
      color: #666;
      line-height: 30px;
    }
  }
  .newsList{
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-wrap: wrap;
    padding:20px 0;
    .news_box{
      width: 280px;
      margin-bottom: 20px;
      margin-right: 20px;
      // box-shadow: 2px 5px 5px 5px #ccc;
      .news_img{
        width: 260px;
        height: 260px;
      }
      .news_title{
        height: 60px;
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;				//溢出内容隐藏
        text-overflow: ellipsis;		//文本溢出部分用省略号表示
        display: -webkit-box;			//特别显示模式
        -webkit-line-clamp: 2;			//行数
        line-clamp: 2;
        -webkit-box-orient: vertical;	//盒子中内容竖直排列
      }
    }
  }
  .pagination_box{
    width: 100%;
    margin-top: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .el-pagination.is-background .el-pager li:not(.disabled).active{
    background-color: #00a73c !important;
    color: #FFF;
  }
  .el-pager li:hover {
    color: #00a73c !important;
  }
</style>



// WEBPACK FOOTER //
// src/pages/reports/newsList.vue